import { render } from "./humanitySubjectMuseum.vue?vue&type=template&id=0d2a303a&scoped=true"
import script from "./humanitySubjectMuseum.vue?vue&type=script&lang=js"
export * from "./humanitySubjectMuseum.vue?vue&type=script&lang=js"

import "./humanitySubjectMuseum.vue?vue&type=style&index=0&id=0d2a303a&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d2a303a"]])

export default __exports__